/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as API from '../http/api';
import * as CustomWidgets from './customwidgets';
import { openlightbox } from '../util/Functions';
import { AccountStatement, StpRegister, SuccessAssign, InfoVirtualCard, CardsCompany, AssignRif, AfbSpace, AlboCard, AlboCardCIH, AccountBlockList, SpaceTxTracking, VerifyInfo, InfoLogTutuka, VerifyMirai, TutukaOperationManual, OpenModalReject, CustomerCancel, AccountCancelBlackList } from './modals';
import Admin from './Admin';
import { InextInit } from './customwidgets/inext-init/InextInit';

const Widgets = (props) => {
    const history = useHistory();
    const [statusAction, setStatusAction] = useState(false);
    useEffect(() => {
        if (props.next) {
            props.updateNext('');
            addWidget('infoPersonal', props.widgets[0].data.content[0].uuid);
        }
    }, []);

    const newWidgets = async (widget, valueSearch) => {
        if (props.makeOp) {
            props.changeLoader(true);

            let request = await API.service(widget, valueSearch, props.pos, props.changeAlert, props.changeLoader, history);

            if (request.status == 200 && request.data.data.response == 'OK') {
                let w = [props.widgets[0]];
                let moreWidgets = w.concat(request.data.data.widget)
                props.changeWidgets(JSON.parse(JSON.stringify(moreWidgets)));
            }
            props.changeLoader(false);
        } else {
            console.log('FALTAN CATALOGOS');
        }
    }

    const addWidget = async (widget, valueSearch, type = ['default'], email = null) => {
        if (Array.isArray(type) && type.indexOf('changeEmail') !== -1) {
            props.updateValueSearch(email);
        }

        props.changeLoader(true);

        let request = await API.service(widget, valueSearch, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status == 200 && request.data.data.response == 'OK') {
            if (Array.isArray(type) && type.indexOf('modal') !== -1) {
                openModal(request.data.data.widget);
            } else {
                props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
            }
        }
        props.changeLoader(false);
    }

    const openModal = (widgets) => {
        for (let w in widgets) {
            const widget = widgets[w];
            if (widget.type === 'estadoCuenta') {
                const as = <AccountStatement dataCostumer={widget?.data?.content} spaces={widget?.data?.spaces}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="accountStatement" />
                openlightbox(as);
            }
            if (widget.type === 'stpRegister') {
                const as = <StpRegister data={widget?.data}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="stpRegister" />
                openlightbox(as);
            }
            if (widget.type === 'successAssign') {
                const as = <SuccessAssign
                    //data={widget?.data}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    contentModal={widget.content}
                    key="stpRegister" />
                openlightbox(as);
            }
            if (widget.type === 'infoVirtualCard') {
                const as = <InfoVirtualCard
                    //data={widget?.data}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    contentModal={widget.content}
                    key="stpRegister" />
                openlightbox(as);
            }
            if (widget.type === 'companyCards') {
                const as = <CardsCompany
                    //data={widget?.data}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    contentModal={widget.content}
                    key="companyCards" />
                openlightbox(as);
            }
            if (widget.type === 'assignRif') {
                const as = <AssignRif
                    //data={widget?.data}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    contentModal={widget.content}
                    updateStatusAction={updateStatusAction}
                    key="assignRif" />
                openlightbox(as);
            }
            if (widget.type === 'afbSpaceCreate') {
                const as = <AfbSpace
                    data={widget.content}
                    pos={props.pos}
                    config={widget.config}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="afbSpaceCreate" />
                openlightbox(as);
            }
            if (widget.type === 'alboCard') {
                const as = <AlboCard
                    data={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="alboCard" />
                openlightbox(as);
            }
            if (widget.type === 'alboCardCIH') {
                const as = <AlboCardCIH
                    data={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="alboCardCIH" />
                openlightbox(as);
            }
            if (widget.type === 'accountBlockList') {
                const as = <AccountBlockList
                    contentModal={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="accountBlockList" />
                openlightbox(as);
            }
            if (widget.type === 'accountCancelBlackList') {
                const as = <AccountCancelBlackList
                    contentModal={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="accountCancelBlackList" />
                openlightbox(as);
            }
            if (widget.type === 'accountCancelBlackList') {
                const as = <AccountCancelBlackList
                    contentModal={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="accountCancelBlackList" />
                openlightbox(as);
            }
            if (widget.type === 'spaceTxTracking') {
                const as = <SpaceTxTracking
                    contentModal={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="spaceTxTracking" />
                openlightbox(as);
            }
            if (widget.type === 'verifyInfo') {
                const as = <VerifyInfo
                    contentModal={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="verifyInfo" />
                openlightbox(as);
            }
            if (widget.type === 'verifyMirai') {
                const as = <VerifyMirai
                    contentModal={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="verifyMirai" />
                openlightbox(as);
            }
            if (widget.type === 'infoLogTutuka') {
                const as = <InfoLogTutuka
                    contentModal={widget.content}
                    catalogs={props.catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="infoLogTutuka" />
                openlightbox(as);
            }
            if (widget.type === 'tutukaOpManual') {
                const as = <TutukaOperationManual
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    contentModal={widget.content}
                    key="tutukaOpManual"
                />
                openlightbox(as);
            }
            if (widget.type === 'openModalReject') {
                const as = <OpenModalReject dataCostumer={widget?.data?.content} spaces={widget?.data?.spaces}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="openModalReject" />
                openlightbox(as);
            }
            if (widget.type === 'customerCancel') {
                const as = <CustomerCancel dataCostumer={widget?.data?.content} spaces={widget?.data?.spaces}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="customerCancel" />
                openlightbox(as);
            }
        }
    }

    const updateStatusAction = (flag, message = false) => {
        if (flag) {
            if (message) {
                props.changeAlert(true, 'ok', message);
            } else {
                props.changeAlert(true, 'ok', 'Datos actualizados con éxito');
            }
        } else {
            if (message) {
                props.changeAlert(true, 'error', message);
            } else {
                props.changeAlert(true, 'error', 'Error en actualización de datos');
            }
        }
        //setStatusAction(flag);
    }

    return (
        <div className={`wrapper-flex ${props.clase}`}>

            {
                props.widgets.map((item, index) => {
                    if(item.type == 'imgDefault'){
                        return <InextInit key={`widget-${index}`} rol={item.rol} />
                    }
                    // if(item.type == 'basic' || item.type == 'table'){
                    //     return <CustomWidgets.Default
                    //         next={props.next}
                    //         addWidget={addWidget} 
                    //         item={item} 
                    //         key={`widget-${index}`}
                    //         openModal={props.openModal}
                    //         changeOpenModal={props.changeOpenModal}
                    //         contentModal={props.contentModal}
                    //         changeContentModal={props.changeContentModal}
                    //         changeAlert={props.changeAlert}
                    //         content={item.content}
                    //         edit={item.edit}
                    //     />
                    // }
                    if (item.type == 'basic' || item.type == 'table') {
                        return <CustomWidgets.DefaultInit
                            next={props.next}
                            addWidget={addWidget}
                            item={item}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            content={item.content}
                            edit={item.edit}
                        />
                    }
                    if (item.type == 'address') {
                        return <CustomWidgets.Address
                            addWidget={addWidget}
                            config={item.config}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            changeContentModal={props.changeContentModal}
                            changeWidgets={props.changeWidgets}
                            changeAlert={props.changeAlert}
                            content={item.content}
                            edit={item.edit}
                            catalogs={props.catalogs}
                            statusAction={statusAction}
                            updateStatusAction={updateStatusAction}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                        />
                    }
                    /*snts*/
                    if (item.type == 'transaction') {
                        return <CustomWidgets.Transaction
                            addWidget={addWidget}
                            item={item}
                            key={`widget-${index}`}
                            edit={item.edit}
                        />
                    }
                    if (item.type == 'infoCuenta') {
                        return <CustomWidgets.AccountInformation
                            data={item.content}
                            catalogs={props.catalogs}
                            addWidget={addWidget}
                            pos={props.pos}
                            changeLoader={props.changeLoader}
                            changeAlert={props.changeAlert}
                            key={`widget-${index}`}
                            config={item.config}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'infoApp' && item.content) {
                        return <CustomWidgets.AppInformation
                            data={item.content}
                            key={`widget-${index}`}
                            config={item.config}
                        />
                    }
                    /*if(item.type == 'cards' && item.data?.content){
                        return <CustomWidgets.Cards
                        next={'nextStep'}
                        addWidget={addWidget} 
                        item={item} 
                        key={`widget-${index}`}
                        openModal={props.openModal}
                        changeOpenModal={props.changeOpenModal}
                        contentModal={props.contentModal}
                        changeContentModal={props.changeContentModal}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        pos={props.pos}
                        config={item.config}
                    />*/
                    if (item.type == 'cards') {
                        return <CustomWidgets.CardList
                            next={'nextStep'}
                            addWidget={addWidget}
                            item={item}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            changeWidgets={props.changeWidgets}
                            config={item.config}
                        />
                    }
                    if (item.type == 'spaces' && item.data?.content) {
                        return <CustomWidgets.Spaces
                            next={'nextStep'}
                            addWidget={addWidget}
                            item={item}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            config={item.config}
                            catalogs={props.catalogs}
                            changeWidgets={props.changeWidgets}
                            updateStatusAction={updateStatusAction}
                        />
                    }
                    if (item.type == 'manualCheckList') {
                        return <CustomWidgets.ManualCheckList
                            content={item.content}
                            total={item.total}
                            pages={item.pages}
                            page={item.page}
                            acc={item.acc}
                            totalPage={item.totalPage}
                            newWidgets={newWidgets}
                            makeOp={props.makeOp}
                            key={`widget-${index}`}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                            updateStatusAction={updateStatusAction}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            changeAlert={props.changeAlert}
                            update={props.update}
                            changeUpdate={props.changeUpdate}
                        />
                    }
                    if (item.type == 'dataPersonal') {
                        return <CustomWidgets.InfoPersonal
                            content={item.content}
                            config={item.config}
                            edit={item.edit}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeLoader={props.changeLoader}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            pos={props.pos}
                            key={`widget-${index}`}
                            updateStatusAction={updateStatusAction}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                            update={props.update}
                            changeUpdate={props.changeUpdate}
                        />
                    }
                    if (item.type == 'identity') {
                        return <CustomWidgets.Identity
                            content={item.content}
                            config={item.config}
                            key={`widget-${index}`}
                            pos={props.pos}
                            changeLoader={props.changeLoader}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                            updateStatusAction={updateStatusAction}
                        />
                    }
                    if (item.type == 'spaceListTx' && item.data?.content) {
                        return <CustomWidgets.SpaceListTx
                            next={props.next}
                            updateNext={props.updateNext}
                            addWidget={addWidget}
                            item={item}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            catalogs={props.catalogs}
                            pos={props.pos}
                            config={item.config}
                        />
                    }
                    if (item.type == 'logisticList') {
                        return <CustomWidgets.LogisticList
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'admin') {
                        return <Admin
                            next={props.next}
                            updateNext={props.updateNext}
                            addWidget={addWidget}
                            item={item}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                        />
                    }
                    if (item.type == 'AssignAfb') {
                        return <CustomWidgets.AssignAfb
                            next={props.next}
                            updateNext={props.updateNext}
                            addWidget={addWidget}
                            item={item}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                        />
                    }
                    if (item.type == 'serviceManagerGet') {
                        return <CustomWidgets.ServiceManagerList
                            next={props.next}
                            updateNext={props.updateNext}
                            addWidget={addWidget}
                            item={item}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            config={item.config}
                        />
                    }
                    if (item.type == 'contactList') {
                        return <CustomWidgets.ContactList
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'afbCustomers') {
                        return <CustomWidgets.AfbCustomerList
                            key={`widget-${index}`}
                            addWidget={addWidget}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'reportCards') {
                        return <CustomWidgets.ReportCards
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'complianceReport') {
                        return <CustomWidgets.ComplianceReport
                            addWidget={addWidget}
                            content={item.content}
                            config={item.config}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'concentratorMessages') {
                        return <CustomWidgets.ConcentratorMessages
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'logisticReport') {
                        return <CustomWidgets.LogisticReport
                            addWidget={addWidget}
                            content={item.content}
                            config={item.config}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'reporteLogTutuka') {
                        return <CustomWidgets.ReportLogTutuca
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-reporteLogTutuka`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'validationResults') {
                        return <CustomWidgets.ValidationResults
                            content={item.content}
                            key={`widget-${index}`}
                        />
                    }
                    if (item.type == 'leadList') {
                        return <CustomWidgets.LeadList
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-leadList`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'agentList') {
                        return <CustomWidgets.AgentList
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-leadList`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }

                    if (item.type == 'alboQueryLanguaje') {
                        return <CustomWidgets.AqlDetail
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-alboQueryLanguaje`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }

                    if (item.type == 'reportManualValidation') {
                        return <CustomWidgets.ReportManualValidation
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'listStatement') {
                        return <CustomWidgets.ListStatement
                            addWidget={addWidget}
                            config={item.config}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            changeContentModal={props.changeContentModal}
                            changeWidgets={props.changeWidgets}
                            changeAlert={props.changeAlert}
                            content={item.content}
                            edit={item.edit}
                            catalogs={props.catalogs}
                            statusAction={statusAction}
                            updateStatusAction={updateStatusAction}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            updateValueSearch={props.updateValueSearch}
                        />
                    }
                    if (item.type == 'listStpRegister') {
                        return <CustomWidgets.ListStpRegister
                            addWidget={addWidget}
                            config={item.config}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            changeContentModal={props.changeContentModal}
                            changeWidgets={props.changeWidgets}
                            changeAlert={props.changeAlert}
                            content={item.content}
                            edit={item.edit}
                            catalogs={props.catalogs}
                            statusAction={statusAction}
                            updateStatusAction={updateStatusAction}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            updateValueSearch={props.updateValueSearch}
                        />
                    }
                    if (item.type == 'adminAbbList') {
                        return <CustomWidgets.AfbAdminList
                            key={`widget-${index}`}
                            addWidget={addWidget}
                            config={item.config}
                            catalogs={props.catalogs}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={item}
                        />
                    }

                    if (item.type == 'unitList') {
                        return <CustomWidgets.UnitList
                            addWidget={addWidget}
                            content={item.content}
                            key={`unitList`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }

                    if (item.type == 'scriptData') {
                        return <CustomWidgets.ScriptData
                            addWidget={addWidget}
                            content={item.content}
                            key={`scriptData`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }

                    if (item.type == 'roleList') {
                        return <CustomWidgets.RoleList
                            addWidget={addWidget}
                            content={item.content}
                            key={`roleList`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }

                    if (item.type == 'widgetsConfig') {
                        return <CustomWidgets.WidgetsConfig
                            addWidget={addWidget}
                            content={item.content}
                            key={`widgetsConfig`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'intentsConfig') {
                        return <CustomWidgets.IntentsConfig
                            addWidget={addWidget}
                            content={item.content}
                            key={`intentsConfig`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'menusConfig') {
                        return <CustomWidgets.MenusConfig
                            addWidget={addWidget}
                            content={item.content}
                            key={`menusConfig`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'factorList') {
                        return <CustomWidgets.FactorList
                            addWidget={addWidget}
                            content={item.content}
                            key={`factorList`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'inextManagerFeatures') {
                        return <CustomWidgets.InextManagerFeatures
                            addWidget={addWidget}
                            content={item.content}
                            key={`inextManagerFeatures`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'validationsList') {
                        return <CustomWidgets.ValidationsList
                            addWidget={addWidget}
                            content={item.content}
                            key={`validationsList`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'blackWhiteList') {
                        return <CustomWidgets.BlackWhiteList
                            addWidget={addWidget}
                            content={item.content}
                            config={item.config}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'cLevelReport') {
                        return <CustomWidgets.CLevelReport
                            addWidget={addWidget}
                            content={item.content}
                            config={item.config}
                            key={`widget-${index}`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'waitingAuthList') {
                        return <CustomWidgets.WaitingAuthList
                            content={item.content}
                            total={item.total}
                            pages={item.pages}
                            page={item.page}
                            acc={item.acc}
                            config={item.config}
                            totalPage={item.totalPage}
                            newWidgets={newWidgets}
                            makeOp={props.makeOp}
                            key={`widget-${index}`}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                            updateStatusAction={updateStatusAction}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            changeAlert={props.changeAlert}
                            update={props.update}
                            changeUpdate={props.changeUpdate}
                            addWidget={addWidget}
                        />
                    }
                    if (item.type == 'limitsBalance') {
                        return <CustomWidgets.LimitsBalanceDetail
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-limitsBalance`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'massCustomerCancel') {
                        return <CustomWidgets.MassCustomerCancel
                            key={`massCustomerCancel`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'massCustomerBlock') {
                        return <CustomWidgets.MassCustomerBlock
                            key={`massCustomerBlock`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'massSpaceCancel') {
                        return <CustomWidgets.MassSpaceCancel
                            key={`massSpaceCancel`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'r27') {
                        return <CustomWidgets.R27List
                            key={`r27List`}
                            content={item.content.data.content}
                            pagination={item.content.data.pagination}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                            config={item.config}
                        />
                    }
                    if (item.type == 'managementDevOps') {
                        return <CustomWidgets.Management
                            addWidget={addWidget}
                            content={item.content}
                            key={`widget-limitsBalance`}
                            openModal={props.openModal}
                            changeOpenModal={props.changeOpenModal}
                            contentModal={props.contentModal}
                            changeContentModal={props.changeContentModal}
                            changeAlert={props.changeAlert}
                            catalogs={props.catalogs}
                            changeLoader={props.changeLoader}
                            pos={props.pos}
                            widgets={props.widgets}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'leadsTrackingReport') {
                        return <CustomWidgets.LeadsTrackingReport
                            key={`widget-leadsTrackingReport`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            config={item.config}
                        />
                    }
                    if (item.type == 'leadsOnboardingSections') {
                        return <CustomWidgets.LeadsOnboardingSections
                            key={`widget-leadsOnboardingSections`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            widgets={item.widgets}
                            config={item.config}
                            catalogs={props.catalogs}
                        />
                    }
                    if (item.type == 'couponsReport') {
                        return <CustomWidgets.CouponsReport
                            key={`widget-couponsReport`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].content}
                        />
                    }
                    if (item.type == 'featureCustomerGet') {
                        return <CustomWidgets.FeatureCustomerGet
                            key={`widget-featureCustomerGet`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                        />
                    }
                    if (item.type == 'featureList') {
                        return <CustomWidgets.FeatureList
                            key={`widget-featureList`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                        />
                    }
                    if (item.type == 'fraudList') {
                        return <CustomWidgets.FraudList
                            key={`widget-fraudList`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            catalogs={{
                                country: props.catalogs['country'],
                                gender: props.catalogs['gender'],
                                occupations: props.catalogs['occupations'],
                                economicActivities: props.catalogs['economicActivities'],
                                customerOrigin: props.catalogs['customerOrigin'],
                            }}
                        />
                    }
                    if (item.type == 'batchNotifications') {
                        return <CustomWidgets.BatchNotifications
                            key={`widget-batchNotifications`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                        />
                    }
                    if (item.type == 'afbAdminCards') {
                        return <CustomWidgets.AfbAdminCards
                            key={`widget-afbAdminCards`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            payload={props.widgets[0].payload}
                        />
                    }
                    if (item.type == 'chargeBacks') {
                        return <CustomWidgets.ChagerBack
                            key={`widget-chargeBacks`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            data={item.content}
                            item={item.customerUuid}
                            config={item.config}
                            addWidget={addWidget}
                            pos={props.pos}
                        />
                    }
                    if (item.type == 'singleCustomerView') {
                        return <CustomWidgets.SingleCustomerView
                            key={`widget-singleCustomerView`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            payload={props.widgets[0].payload}
                        />
                    }
                    if (item.type == 'panelCrmList') {
                        return <CustomWidgets.CRMTable
                            key={`widget-panelCrmList`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            crmType={item.crmType || props.widgets[0].payload}
                            crmContactFlow={props.widgets[0]['crmContactFlow']}
                            catalogs={props.catalogs['country']}
                            config={item.config}
                            selectedSection={item["selectedSection"] || null}
                            forms={item.forms}
                        />
                    }
                    if (item.type == 'leadCRMDetail') {
                        return <CustomWidgets.CRMLeadDetail
                            key={`widget-leadCRMDetail`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            config={item.config}
                            crmType={item.crmType}
                            selectedSection={item.selectedSection}
                            catalogs={props.catalogs['country']}
                            platformData={item.platformData}
                            platformInfo={item.platformInfo}
                            forms={item.forms}
                            agentList={item.agentList}
                            segments={item.segments}
                            companyGroups={item.companyGroups}
                            partnersList={item.partnersList}
                            crmContactFlow={props.widgets[0]['crmContactFlow']}
                        />
                    }
                    if (item.type == 'commissionCrmList') {
                        return <CustomWidgets.CRMCommissionsTable
                            key={`widget-commissionCrmList`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            sectionData={props.widgets[0].data}
                        />
                    }
                    if (item.type == 'sellerCrmList') {
                        return <CustomWidgets.CRMSellersTable
                            key={`widget-sellerCrmList`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            sectionData={props.widgets[0].data}
                        />
                    }
                    if (item.type == 'rewardsPromotionsGet') {
                        return <CustomWidgets.CouponsReward
                            key={`widget-rewardsPromotionsGet`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            catalogs={item.catalog}
                            config={item.config}
                        />
                    }
                    if (item.type == 'customerVipList') {
                        return <CustomWidgets.CustomerVipList
                            key={`widget-customerVipList`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            config={item.config}
                            catalog={props.catalogs['country']}
                        />
                    }
                    if (item.type == 'companyList') {
                        return <CustomWidgets.CompanyOnboardingList
                            key={`widget-companyList`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            config={item.config}
                        />
                    }
                    if (item.type == 'spaceTxPending') {
                        return <CustomWidgets.SpaceTxPending
                            key={`widget-spaceTxPending`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                            sectionData={props.widgets[0].data}
                            config={item.config}
                        />
                    }
                    if (item.type == 'afbRecurringList') {
                        return <CustomWidgets.AfbRecurringOperation
                            key={`widget-${index}`}
                            sectionData={props.widgets[0].data}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'customerHistoryGet') {
                        return <CustomWidgets.CustomerHistoryGet
                            key={`widget-${index}`}
                            sectionData={props.widgets[0].data}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            changeWidgets={props.changeWidgets}
                        />
                    }
                    if (item.type == 'afbFeeSimulation') {
                        return <CustomWidgets.AfbFeeSimulation
                            key={`widget-afbFeeSimulation`}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                        />
                    }
                })
            }

        </div>
    )
}

export default Widgets;

